export const titleTrans = {
  'New of Top 10 Countries': 'ua_Top_Country',
  'New of Top 10 Regions': 'ua_Top_Region',
  'New of Network Type': 'ua_Top_Network',
  'New of Top 10 Zones': 'ua_Top_Zone',

  'DAU of Top 10 Countries': 'engagement_active_activeUsers_dau_of_top_10_countries',
  'DAU of Top 10 Regions': 'engagement_active_activeUsers_dau_of_top_10_regions',
  'DAU of Top 10 Zones': 'engagement_active_activeUsers_dau_of_top_10_zones',

  'WAU of Top 10 Countries': 'engagement_active_activeUsers_wau_of_top_10_countries',
  'WAU of Top 10 Regions': 'engagement_active_activeUsers_wau_of_top_10_regions',
  'WAU of Top 10 Zones': 'engagement_active_activeUsers_wau_of_top_10_zones',

  'MAU of Top 10 Countries': 'engagement_active_activeUsers_mau_of_top_10_countries',
  'MAU of Top 10 Regions': 'engagement_active_activeUsers_mau_of_top_10_regions',
  'MAU of Top 10 Zones': 'engagement_active_activeUsers_mau_of_top_10_zones',

  'CPA of Top 10 Countries': 'ua_CPA_Top_Countries',
  'CPA of Top 10 Regions': 'ua_CPA_Top_Region',
  'CPA of Network Type ': 'ua_CPA_Top_Network',

  'LTV7 of Top 10 Countries': 'ua_Ltv7_Top_Country',
  'LTV7 of Top 10 Regions': 'ua_Ltv7_Top_Region',
  'LTV7 of Network Type ': 'ua_Ltv7_Top_Network',

  'Churn of Top 10 Countries': 'engagement_churn_rank_title_country',
  'Churn of Top 10 Regions': 'engagement_churn_rank_title_region',
  'Churn of Top 10 Zones': 'engagement_churn_rank_title_zone',

  'New of Platform': 'register_top_10_platform',
  'New of Language': 'register_top_10_language',
};
// 排行榜浮窗需要处理$的指标(取得接口返回key)
const formaterUnitMetricsList: any = [
  'Units_dlc_revenue',
  'Platform_net_revenue',
  'Units_net_revenue',
  'Dlc_net_revenue',
  'Mtx_revenue',
  'Mtx_arpu',
  'Mtx_arppu',
  'Platform_revenue',
  'Platform_arpu',
  'Platform_arppu',
  'Platform_mtx_revenue',
  'Platform_mtx_arpu',
  'Platform_mtx_arppu',
  'Net_revenue',
];
export const unitMetricsList = [
  ...formaterUnitMetricsList,
  'CPA($)',
  'Avg. CPA($)',
  'Revenue',
  'Revenue After Refund & Tax',
  'Sum Revenue After Refund & Tax',
  'Inflexion_revenue',
  'Sum Inflexion_revenue',
  'Sum Revenue',
  'In-Game Revenue',
  'Sum In-Game Revenue',
  'In-Game ARPU',
  'Avg. In-Game ARPU',
  'Avg. In-Game  ARPU_Day',
  'Avg. In-Game  ARPU_Week',
  'Avg. In-Game  ARPU_Month',
  'In-Game ARPPU',
  'Avg. In-Game ARPPU',
  'Avg. In-Game  ARPPU_Day',
  'Avg. In-Game  ARPPU_Week',
  'Avg. In-Game  ARPPU_Month',
  'MTX Revenue',
  'Sum MTX Revenue',
  'MTX ARPU',
  'Avg. MTX ARPU',
  'MTX ARPPU',
  'Avg. MTX ARPPU',
  'ASP',
  'Refunds',
  'Avg ASP',
  'Mtx Revenue',
  'Sum Refunds',
  'Asp',
  'Inflexion_revenue',
  'platform net revenue',
  'Sum platform net revenue',
  'MTX_REVENUE',
  'Sum Mtx Revenue',
  'Sum Base Game Revenue After Refund & Tax',
  'Gross Revenue',
  'Sum Gross Revenue',
  'GROSS_REVENUE',
];
const formaterPercentMetricsList: any = ['Mtx_payer_rate'];
export const percentMetricsList = [...formaterPercentMetricsList, 'In-Game Payer%', 'Avg. In-Game Payer%', 'MTX Payer%', 'Avg. MTX Payer%', 'Avg. In-Game Payer%_Day', 'Avg. In-Game Payer%_Week', 'Avg. In-Game Payer%_Month'];

export const headerText: any = {
  'Country': 'common_Country',
  'Region': 'common_Region',
  'Network type': 'common_netWork_Type',
  'Zone': 'common_Zone',
  'Os': 'common_System',
  'Lang': 'common_Language',
  "Ua network": "common_ua_network",
  "Version": "common_version",
  'Register': 'ua_chart_register',
  'CPA($)': 'ua_table_cpa',
  'LTV7': 'ua_LTV7',
  'Sum Register': 'ua_Sum_Register',
  'Share of ALL': 'ua_Share_of_ALL',
  'Discount': 'common_discount',
  'Avg.Discount': 'common_discount_avg',
  'Avg. LTV7': 'ua_Avg_LTV7',
  'Avg. CPA($)': 'ua_Avg_CPA',
  'Sum Return': 'return_Sum_Retrun',
  'Return': 'return_return',
  'New': 'engagement_register_New',
  'Sum New': 'engagement_register_Sum_New',
  'Network_type': 'common_netWork_Type',
  'Avg WAU': 'engagement_active_activeUsers_breakdown_week_au_avg',
  'WAU': 'engagement_active_activeUsers_breakdown_week_au',
  'Avg DAU': 'engagement_active_activeUsers_breakdown_day_au_avg',
  'DAU': 'engagement_active_activeUsers_breakdown_day_au',
  'Avg MAU': 'engagement_active_activeUsers_breakdown_month_au_avg',
  'MAU': 'engagement_active_activeUsers_breakdown_month_au',
  'Revenue': 'pc_monetization_revenue',
  'Sum Revenue': 'pc_monetization_revenue_sum',
  'Revenue After Refund & Tax': 'pc_monetization_net_revenue',
  'Sum Revenue After Refund & Tax': 'pc_monetization_net_revenue_sum',
  'Units': 'pc_monetization_units',
  'Base Game Units After Refund': 'pc_monetization_full_units',
  'Sum Base Game Units After Refund': 'pc_monetization_full_units_sum',
  'In-Game Revenue': 'pc_monetization_mtx_Rev',
  'Sum In-Game Revenue': 'pc_monetization_mtx_Rev_sum',
  'Share': 'engagement_churn_Share_Of_All',

  'In-Game ARPU': 'pc_monetization_mtx_arpu',
  'Avg. In-Game ARPU': 'pc_monetization_mtx_arpu_avg',
  'Avg. In-Game  ARPU_Day': 'pc_monetization_mtx_arpu_avg_day',
  'Avg. In-Game  ARPU_Week': 'pc_monetization_mtx_arpu_avg_week',
  'Avg. In-Game  ARPU_Month': 'pc_monetization_mtx_arpu_avg_month',

  'In-Game ARPPU': 'pc_monetization_mtx_arppu',
  'Avg. In-Game ARPPU': 'pc_monetization_mtx_arppu_avg',
  'Avg. In-Game  ARPPU_Day': 'pc_monetization_mtx_arppu_avg_day',
  'Avg. In-Game  ARPPU_Week': 'pc_monetization_mtx_arppu_avg_week',
  'Avg. In-Game  ARPPU_Month': 'pc_monetization_mtx_arppu_avg_month',

  'In-Game Payer': 'pc_monetization_mtx_payer',
  'Avg. In-Game Payer': 'pc_monetization_mtx_payer_avg',
  'Avg. In-Game  Payer_Day': 'pc_monetization_mtx_payer_avg_day',
  'Avg. In-Game  Payer_Week': 'pc_monetization_mtx_payer_avg_week',
  'Avg. In-Game  Payer_Month': 'pc_monetization_mtx_payer_avg_month',

  'In-Game Payer%': 'pc_monetization_mtx_payer_rate',
  'Avg. In-Game Payer%': 'pc_monetization_mtx_payer_rate_avg',
  'Avg. In-Game Payer%_Day': 'pc_monetization_mtx_payer_rate_avg_day',
  'Avg. In-Game Payer%_Week': 'pc_monetization_mtx_payer_rate_avg_week',
  'Avg. In-Game Payer%_Month': 'pc_monetization_mtx_payer_rate_avg_month',
  'ASP': 'nightingale_daily_asp$',
  'Refunds': 'nightingale_daily_refunds$',
  'Avg ASP': 'nightingale_avg_asp$',
  'Sum Refunds': 'nightingale_sum_refunds$',
  'Avg Dau': 'engagement_active_activeUsers_breakdown_day_au_avg',
  'Reactivated': 'nightingale_daily_reactivated',
  'Sum Reactivated': 'nightingale_sum_reactivated',
  'full game units': 'pc_overview_Units',
  'Sum full game units': 'pc_overview_sum_units',
  'platform net revenue': 'pc_overview_Revenue($)',
  'Sum platform net revenue': 'pc_monetization_net_revenue_sum',
  'Mtx Revenue': 'pc_monetization_mtx_Revenue($)',
  'Sum Mtx Revenue': 'pc_overview_area_mtx_revenue_table_header2_sum($)',
  'Sum New Churn': 'engagement_churn_Sum_Churn_Ni',
  'Sum Net Units': 'pc_console_revenue_sum_net_units',
  'Sum Base Game Revenue After Refund & Tax': 'pc_console_revenue_sum_net_full_game_revenue',
  'Gross Revenue': 'pc_console_sales_overview_gross_revenue',
  'Sum Gross Revenue': 'pc_console_revenue_sum_gross_revenue',
  'Sum Gross Units': 'pc_console_revenue_sum_gross_units',
  'Gross Base Game Units': 'pc_console_revenue_gross_base_game_units',
  'Sum Gross Base Game Units': 'pc_console_revenue_sum_gross_full_game_units',
  'Sum Refund Revenue': 'pc_console_revenue_sum_refund_revenue',
  'Sum Refunded Units': 'pc_console_revenue_sum_refunded_units',
  'Sum Third-party Units': 'pc_console_sum_third_party_units',
  'Sum Accumulated Refund Rate': 'pc_console_sum_accumaulated_refund_rate',
  'Sum Average Selling Price (ASP)': 'pc_console_sum_avg_selling_price_asp',
  'Revenue V4': 'pc_overview_Revenue_v4',
  'Sum Revenue V4': 'pc_overview_Revenue_v4_total',
  // dl2配置
  'MTX Revenue': 'pc_monetization_mtx_Rev_dl2',
  'Sum MTX Revenue': 'pc_monetization_mtx_Rev_sum_dl2',
  'MTX ARPU': 'pc_monetization_mtx_arpu_dl2',
  'Avg. MTX ARPU': 'pc_monetization_mtx_arpu_avg_dl2',
  'MTX ARPPU': 'pc_monetization_mtx_arppu_dl2',
  'Avg. MTX ARPPU': 'pc_monetization_mtx_arppu_avg_dl2',
  'MTX Payer': 'pc_monetization_mtx_payer_dl2',
  'Avg. MTX Payer': 'pc_monetization_mtx_payer_avg_dl2',
  'MTX Payer%': 'pc_monetization_mtx_payer_rate_dl2',
  'Avg. MTX Payer%': 'pc_monetization_mtx_payer_rate_avg_dl2',
  // wow
  'Player Dau': 'wow_player_dau',
  'Avg Player Dau': 'wow_avg_player_dau',
  'Player New': 'wow_player_new',
  'Avg Player New': 'wow_avg_player_new',
  'Player Return': 'wow_player_return',
  'Avg Player Return': 'wow_avg_player_return',
  'Creator Dau': 'wow_creator_dau',
  'Avg Creator Dau': 'wow_avg_creator_dau',
  'Creator New': 'wow_creator_new',
  'Avg Creator New': 'wow_avg_creator_new',
  'Creator Return': 'wow_creator_return',
  'Avg Creator Return': 'wow_avg_creator_return',

};
